import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  justify-content: end;
`;

export const Wrapper = styled.div`
  line-height: 2rem;
  border-radius: 0.5rem;
  background: #fff;
  padding: 2rem;
`;
export const Content = styled.div`
  color: #000;
  font-weight: 600;
`;
